import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { Subscription } from 'rxjs';
import { MultiBuyerSession } from '../../shared/services/multi-buyer/multi-buyer-session';
import { AuthService } from '../../auth/auth.service';
import { MultiBuyerCmp } from '../../shared/interfaces/company.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'ps-multi-buyer-modal',
  templateUrl: './multi-buyer-modal.component.html',
  styleUrls: ['./multi-buyer-modal.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class MultiBuyerModalComponent implements OnInit, OnDestroy {
  multiBuyersCmpsList: MultiBuyerCmp[] = [];
  selectedCompany?: MultiBuyerCmp;
  isMultiBuyerModal: boolean = true;
  isConfirmDisabled = true;
  private _subscriptions: Subscription = new Subscription();
  private readonly _noCompanyRequiredUrls = ['/dashboard'];

  constructor(
    @Inject(ModalData)
    private _modalData: {
      cmpId: number;
      buyerCompanyId: number;
    },
    private readonly _router: Router,
    readonly _modalRef: ModalRef<MultiBuyerModalComponent, string>,
    readonly _auth: AuthService,
    readonly _toastr: ToasterService,
    readonly _multiBuyerService: MultiBuyerSession
  ) {}

  ngOnInit(): void {
    this._subscriptions.add(
      this._auth.multiBuyerModalCloseRequests$.subscribe(() => {
        this._modalRef.disableClose = false;
        this._modalRef.close();
      })
    );

    this._subscriptions.add(
      this._auth.selectedMultiBuyerCompany$.subscribe((company) => {
        this.selectedCompany = company;
        this._updateConfirmState();
      })
    );
    this.loadBuyers();
  }

  public get canClose(): boolean {
    if (this._auth.selectedMultiBuyerCompany) {
      return true;
    }
    return false;
  }

  public async loadBuyers() {
    try {
      this.multiBuyersCmpsList = await this._multiBuyerService.buyers(
        this._modalData.cmpId,
        this._modalData.buyerCompanyId
      );
    } catch (error) {
      console.error(error);
    }
  }

  private _updateConfirmState(): void {
    const isOptional = this._noCompanyRequiredUrls.some((route) =>
      this._router.url.includes(route)
    );
    this.isConfirmDisabled = isOptional ? false : !this.selectedCompany;
  }

  public chooseBuyer(company: MultiBuyerCmp): void {
    this.selectedCompany = company;
    this._updateConfirmState();
  }

  public clearBuyer() {
    this.selectedCompany = undefined;
    this._updateConfirmState();
  }

  public async confirmSelection() {
    this._modalRef.disableClose = false;
    if (!this.selectedCompany?.id) {
      this._auth.resetMultiBuyerToken();
      this._modalRef.disableClose = false;
      this._modalRef.close();
      return;
    }

    await this._multiBuyerService
      .selectBuyer(this._modalData.cmpId, this.selectedCompany.id)
      .catch((error) => {
        this._toastr.error(error);
      });

    this._modalRef.close();
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }
}
